<script setup lang="ts">
import { RouterLink } from 'vue-router';

import env from '~/env';
import useSearchParams from '~/hooks/useSearchParams';
import useAuth from '~/store/auth/useAuth';

const [params, setParam] = useSearchParams();

const {
  data: auth,
} = useAuth();

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  setParam({ [target.name]: target.value });
};

const onSubmit = (e: Event) => {
  e.preventDefault();
};
</script>

<template>
  <div class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Olá bem vindo, ao teste frontend ambiente de testes de front {{ auth?.person.fullname }} # {{ auth?.person.id }}</h1>
        <p class="subtitle">Value from variable: {{ env.VITE_ENVIRONMENT_NAME }}</p>
        <hr>

        <form @submit="onSubmit" class="columns">
          <div class="column">

            <div class="field">
              <label class="label" for="search">Busque algo</label>
              <div class="control">
                <input
                  :value="params.get('name')"
                  @input="onChange"
                  class="input"
                  id="search"
                  name="name"
                  placeholder="Busque"
                  type="search"
                />
              </div>
            </div>
          </div>

          <div class="column">

            <!-- Seleção de Categorua -->
            <div class="field">
              <label class="label" for="category">Categoria</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select
                    :value="params.get('category')"
                    @input="onChange"
                    id="category"
                    name="category"
                  >
                    <option value="">Selecione</option>
                    <option value="1">Categoria 1</option>
                    <option value="2">Categoria 2</option>
                    <option value="3">Categoria 3</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
        <hr>
        <p>
          <RouterLink to="/page1">Page 1</RouterLink>
          <RouterLink to="/page2">Page 2</RouterLink>
          <RouterLink to="/page3">Page 3</RouterLink>
        </p>

        <p>
          Foo
        </p>
      </div>
    </div>

    <div class="hero-footer">
      <footer class="footer">
        <div class="content has-text-centered">
          <p>
            <strong>{{ env.VITE_APP_VERSION }}</strong>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>
